import type { SessionStepDto } from '../../schemas/sessionSchemas';
import type { SessionStepModule } from '../types';
import { EsignStepDetail } from './EsignStepDetail';
import { EsignStepRunner } from './EsignStepRunner';

/**
 * The eSign Document Template step. Signs the document a preceding Document
 * Template step generated; a workflow without one generates and stops there.
 */
export function isEsignTemplateStep(step: SessionStepDto): boolean {
  return step.stepType === 'esign_template';
}

export const esignTemplateStepModule: SessionStepModule = {
  key: 'esign_template',
  matches: isEsignTemplateStep,
  Runner: EsignStepRunner,
  Detail: EsignStepDetail,
};
